import { render } from "./WelcomeCardsComp.vue?vue&type=template&id=26805e3a&scoped=true&ts=true"
import script from "./WelcomeCardsComp.vue?vue&type=script&lang=ts"
export * from "./WelcomeCardsComp.vue?vue&type=script&lang=ts"

import "./WelcomeCardsComp.vue?vue&type=style&index=0&id=26805e3a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26805e3a"]])

export default __exports__